"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcDataTableRadioGroupBehavior = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var bc_data_table_constants_1 = require("./bc-data-table-constants");
var bc_data_table_header_selection_behavior_1 = require("./bc-data-table-headers/bc-data-table-header-selection-behavior");
var BcDataTableRadioGroupBehavior = (function () {
    function BcDataTableRadioGroupBehavior(config) {
        this.config = config;
        this.bcDataTableConfig = config;
        this.bcDataTable = document.getElementById(this.bcDataTableConfig.id);
        this.bcDataTableHeaderSelectionBehavior = new bc_data_table_header_selection_behavior_1.BcDataTableHeaderSelectionBehavior(this.bcDataTableConfig);
    }
    BcDataTableRadioGroupBehavior.prototype.getRadioGroup = function (name) {
        var radioLabelElement = document.createElement(common_constants_1.BcCommonConstants.LABEL_TAG);
        radioLabelElement.classList.add(common_constants_1.BcCommonConstants.BC_RADIO_LABEL);
        var radioElement = document.createElement(common_constants_1.BcCommonConstants.INPUT_TAG);
        radioElement.setAttribute(bc_data_table_constants_1.BcDataTableConstansts.ATTRIBUTE_TYPE, bc_data_table_constants_1.BcDataTableConstansts.RADIO_TYPE);
        radioElement.setAttribute(bc_data_table_constants_1.BcDataTableConstansts.ATTRIBUTE_NAME, name);
        radioLabelElement.appendChild(radioElement);
        return radioLabelElement;
    };
    BcDataTableRadioGroupBehavior.prototype.getTbodyRadioGroup = function (name) {
        var radioGroupElement = this.getRadioGroup(name);
        var inputRadio = radioGroupElement.querySelector(common_constants_1.BcCommonConstants.INPUT_TAG);
        inputRadio.addEventListener(common_constants_1.BcCommonConstants.EVENT_CHANGE, this.handleBodyRadioGroupChange.bind(this));
        return radioGroupElement;
    };
    BcDataTableRadioGroupBehavior.prototype.handleBodyRadioGroupChange = function (event) {
        this.resetRadioSelected();
        var radioClicked = event.target;
        var trRadioClicked = radioClicked.closest(common_constants_1.BcCommonConstants.TR_TAG);
        var objectId = trRadioClicked.getAttribute(bc_data_table_constants_1.BcDataTableConstansts.ROW_ID);
        var rowIndexRadioClicked = this.findIndexById(this.bcDataTableConfig.data, objectId);
        var checkObject = __assign({}, this.bcDataTableConfig.data[rowIndexRadioClicked][0]);
        checkObject.value = radioClicked.checked;
        this.bcDataTableConfig.data[rowIndexRadioClicked][0] = checkObject;
        this.setStyleSelectedThRow(trRadioClicked, radioClicked.checked);
        var tabsHeader = this.bcDataTableHeaderSelectionBehavior.getTabsContainerActions();
        this.bcDataTableHeaderSelectionBehavior.checkStateRadio(this.bcDataTable, tabsHeader);
    };
    BcDataTableRadioGroupBehavior.prototype.resetRadioSelected = function () {
        var _this = this;
        this.bcDataTableConfig.data.forEach(function (row) {
            var checkObject = __assign({}, row[0]);
            checkObject.value = false;
            row[0] = checkObject;
        });
        var tbody = this.bcDataTable.querySelector(common_constants_1.BcCommonConstants.TBODY_TAG);
        var trRows = Array.from(tbody.querySelectorAll(common_constants_1.BcCommonConstants.TR_TAG));
        trRows.forEach(function (trRow) {
            var inputRadio = trRow.querySelector(common_constants_1.BcCommonConstants.INPUT_TAG);
            if (inputRadio) {
                _this.setStyleSelectedThRow(trRow, inputRadio.checked);
            }
        });
    };
    BcDataTableRadioGroupBehavior.prototype.findIndexById = function (data, id) {
        for (var i = 0; i < data.length; i++) {
            var innerArray = data[i];
            var idObject = innerArray.find(function (obj) { return obj.type === common_constants_1.BcCommonConstants.ID; });
            if (idObject && idObject.value == id) {
                return i;
            }
        }
        return -1;
    };
    BcDataTableRadioGroupBehavior.prototype.setStyleSelectedThRow = function (trRow, isChecked) {
        if (isChecked) {
            trRow.classList.add(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_TR_SELECTED_CLASS);
        }
        else {
            trRow.classList.remove(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_TR_SELECTED_CLASS);
        }
    };
    return BcDataTableRadioGroupBehavior;
}());
exports.BcDataTableRadioGroupBehavior = BcDataTableRadioGroupBehavior;
